export enum DateFilterEnum {
  HOY=0,
  AYER=1,
  SEMANA=2,
  TODOS=3,
}
